import gql from 'graphql-tag'

export const REPORT_CHEF_ISSUE = gql`
  mutation ReportChefIssue($id: ID!, $data: IssueCreateData!) {
    reportChefIssue(id: $id, data: $data) {
      id
    }
  }
`

export const REPORT_ORDER_ISSUE = gql`
  mutation ReportOrdersIssue($id: ID!, $data: IssueCreateData!) {
    reportOrderIssue(id: $id, data: $data) {
      id
    }
  }
`
